export default {
  name: 'v-icon',
  props: {
    path: {
      type: String,
      required: true,
    },
    svgStyle: {
      type: Object,
      required: false,
      default() {
        return {
          width: '100%',
          height: '100%',
        };
      },
    },
  },
  data() {
    return {
      icon: require(`@/assets/${this.path}`),
    };
  },
  render(h) {
    if (typeof this.icon === 'object') {
      return h(this.icon.default, { style: this.svgStyle });
    }

    return h('img', {
      attrs: {
        src: this.icon,
      },
    });
  },
};
